import React from 'react';

/**
 * Calm, teacher-facing error state for failed page loads (2026-07 audit,
 * step 5). Pairs with usePageLoad: message adapts to the failure kind, Retry
 * re-runs the load. Diagnostic detail stays in the console, not on screen.
 */
function messageFor(error) {
  const code = error?.code || '';
  if (code === 'permission-denied') {
    return "We couldn't load this page because your account doesn't have access to some of its data yet. If your account was just set up, please sign out and sign back in. If that doesn't help, contact your administrator.";
  }
  if (code === 'failed-precondition') {
    return 'This page is temporarily unavailable while the system finishes an update. Please try again in a few minutes.';
  }
  if (code === 'timeout' || code === 'unavailable') {
    return 'Loading is taking longer than expected. Please check your internet connection and try again.';
  }
  return "Something went wrong while loading your data. Please try again.";
}

export default function LoadErrorNotice({ error, onRetry, compact = false }) {
  return (
    <div
      role="alert"
      style={{
        margin: compact ? '8px 0' : '40px auto',
        maxWidth: 520,
        padding: '20px 24px',
        borderRadius: 12,
        border: '1px solid #fecaca',
        background: '#fef2f2',
        color: '#7f1d1d',
        textAlign: 'center',
      }}
    >
      <p style={{ margin: '0 0 14px', fontSize: '0.95em', lineHeight: 1.5 }}>
        {messageFor(error)}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            padding: '9px 22px',
            borderRadius: 8,
            border: 'none',
            background: '#3b82f6',
            color: 'white',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Retry
        </button>
      )}
    </div>
  );
}
